export default __webpack_public_path__ + "static/media/Old-Violet.d316e780.jpg";